import type { Scope, UserRoleAssignment } from '../types';

export interface ScopeValue {
  scope: Scope;
  districtId: string;
  regionId: string;
}

export const emptyScope: ScopeValue = { scope: 'NATIONAL', districtId: '', regionId: '' };

/** Complete when a district / region is chosen for the scopes that need one */
export const isScopeComplete = (v: ScopeValue) =>
  v.scope === 'NATIONAL' || (v.scope === 'DISTRICT' && !!v.districtId) || (v.scope === 'REGION' && !!v.regionId);

const SCOPE_LABEL = { NATIONAL: 'Nacional', DISTRICT: 'Distrito', REGION: 'Región' } as const;

export const scopeText = (a: Pick<UserRoleAssignment, 'scope' | 'district_name' | 'region_name'>) =>
  a.scope === 'NATIONAL' ? 'Nacional' : `${SCOPE_LABEL[a.scope]}: ${a.district_name ?? a.region_name ?? '—'}`;
